import { openDB, IDBPDatabase } from 'idb';

export const DB_NAME = 'UserSettingsDB';
export const DB_VERSION = 3;

export const STORE_NAMES = {
  layout: 'LayoutStore',
  filter: 'FilterStore',
} as const;

export type StoreNames = typeof STORE_NAMES[keyof typeof STORE_NAMES];

let dbInstance: Promise<IDBPDatabase> | null = null;

export const openIndexDb = (): Promise<IDBPDatabase> => {
  if (!dbInstance) {
    dbInstance = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        for (const store of Object.values(STORE_NAMES)) {
          if (!db.objectStoreNames.contains(store)) {
            db.createObjectStore(store);
          }
        }
      },
    });
  }
  return dbInstance;
};

export const closeIndexDb = (): void => {
  if (dbInstance) {
    dbInstance = null;
  }
};
